import { createFileRoute } from "@tanstack/react-router";

import { LegalPage, LegalSection, CONTACT_EMAIL } from "@/components/legal-page";

export const Route = createFileRoute("/terms")({
  component: TermsPage,
  head: () => ({
    meta: [
      { title: "Terms & Conditions | Civil Campus Ambassador Program" },
      {
        name: "description",
        content:
          "Terms and conditions for the Civil Engineering Campus Ambassador Program in Bengaluru, including commission rules, eligibility and conduct.",
      },
      { property: "og:title", content: "Terms & Conditions | Campus Ambassador Program" },
      {
        property: "og:description",
        content:
          "Read the commission, eligibility and conduct terms for the Civil Engineering Campus Ambassador Program.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
});

function TermsPage() {
  return (
    <LegalPage
      title="Terms & Conditions"
      updated="4 August 2026"
      intro="These terms govern your participation as a Campus Ambassador. By submitting an application you confirm that you have read and accepted them."
    >
      <LegalSection heading="1. Eligibility">
        <p>
          The program is open to Civil Engineering degree students, Diploma Civil
          students, final-year students and fresh graduates from colleges in and around
          Bengaluru. You must provide accurate college, branch and contact details in
          your application.
        </p>
      </LegalSection>

      <LegalSection heading="2. Selection & Training">
        <p>
          Applications are reviewed by our campus team. Selection is at our sole
          discretion and being shortlisted does not guarantee onboarding. Selected
          ambassadors receive free product and sales training before they start
          promoting.
        </p>
      </LegalSection>

      <LegalSection heading="3. Commission">
        <ul className="list-disc space-y-2 pl-5">
          <li>
            ₹500 commission is payable per successful, fully paid software license sale
            attributed to your referral code or link.
          </li>
          <li>
            Payouts are processed monthly for sales confirmed in the previous calendar
            month, after the refund window closes.
          </li>
          <li>
            Cancelled, refunded, duplicate or fraudulent orders are not eligible for
            commission and may be reversed.
          </li>
        </ul>
      </LegalSection>

      <LegalSection heading="4. Ambassador Conduct">
        <p>
          You must represent the program honestly. Misleading pricing claims, spam,
          impersonation of company staff, unauthorised discounts, or use of a college
          logo or name without permission are not allowed and can lead to immediate
          removal from the program.
        </p>
      </LegalSection>

      <LegalSection heading="5. Rewards & Certificates">
        <p>
          Certificates, LinkedIn recommendations, internship consideration and monthly
          performance rewards are issued based on verified performance and completion of
          the minimum program duration. Reward items may be substituted with an item of
          similar value.
        </p>
      </LegalSection>

      <LegalSection heading="6. Independent Relationship">
        <p>
          Ambassadors are independent participants, not employees. The program does not
          create an employment, agency or partnership relationship, and there is no fixed
          salary or guaranteed income.
        </p>
      </LegalSection>

      <LegalSection heading="7. Changes & Termination">
        <p>
          We may update these terms, commission structure or reward list with prior
          notice on this page. Either side may exit the program at any time; commission
          already earned on verified sales will still be paid.
        </p>
      </LegalSection>

      <LegalSection heading="8. Contact">
        <p>
          For any question about these terms, write to{" "}
          <a
            className="font-semibold text-primary hover:underline"
            href={`mailto:${CONTACT_EMAIL}`}
          >
            {CONTACT_EMAIL}
          </a>
          .
        </p>
      </LegalSection>
    </LegalPage>
  );
}
